/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useMemo } from "react";

import { usePushRoute } from "hooks";
import { useQuery } from "react-query";
import { Status } from "services/types";
import { getLabelPayrollCycle } from "utils";

import { payrollCycleListShortService } from "./services";

export const useDefaultPayrollCycle = ({
  enabled = true,
  methods,
  field,
}: {
  enabled: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  methods: any;
  field: string;
}) => {
  const { searchLocation } = usePushRoute();

  useQuery({
    queryKey: "payrollCycleListShortService",
    enabled,
    queryFn: () => payrollCycleListShortService({ page: 1, limit: 100 }),
    onSuccess: (res) => {
      const firstItem = res?.data?.items?.[0];
      if (firstItem) {
        if (searchLocation?.cycleIdValue) {
          const cycleSelected = res?.data?.items?.find(
            (item) => item.id === searchLocation?.cycleIdValue
          );
          if (cycleSelected) {
            methods?.setValue(field, {
              label: getLabelPayrollCycle(cycleSelected),
              value: cycleSelected?.id,
              original: firstItem,
            });
          } else {
            methods?.setValue(field, {
              label: getLabelPayrollCycle(firstItem),
              value: firstItem.id,
              original: firstItem,
            });
          }
        } else {
          methods?.setValue(field, {
            label: getLabelPayrollCycle(firstItem),
            value: firstItem.id,
            original: firstItem,
          });
        }
      }
    },
  });

  return {};
};

export const usePayrollCycleShort = () => {
  const listQuery = useQuery({
    queryKey: "payrollCycleListShortService",
    queryFn: () =>
      payrollCycleListShortService({
        page: 1,
        limit: 100,
        status: Status.Active,
      }),
  });
  const options = useMemo(() => {
    return listQuery?.data?.data?.items?.map((item) => ({
      label: getLabelPayrollCycle(item),
      value: item.id,
    }));
  }, [listQuery?.data?.data?.items]);

  return {
    options,
    data: listQuery?.data?.data?.items,
    loading: listQuery?.isFetching,
  };
};
